/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJob {
    getFixupPrototypeFunction() { return BackgroundJob.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJob>): BackgroundJob {
        let obj = Object.assign(new BackgroundJob(), model);
        BackgroundJob.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJob>): BackgroundJob {
        if (!model) return null;
        return BackgroundJob.newInstance(<BackgroundJob> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJob) {
        if (!obj) return;

        models.BackgroundJob.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJob): boolean {
        Object.setPrototypeOf(obj, BackgroundJob.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.priority === undefined) {
            this.priority = 0;
        }
        if (this.auto_retries === undefined) {
            this.auto_retries = 0;
        }
        if (this.auto_retry_delay === undefined) {
            this.auto_retry_delay = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (typeof this.next_activation === "string") {
            this.next_activation = new Date(<string><any>this.next_activation);
        }
        if (typeof this.execution_start === "string") {
            this.execution_start = new Date(<string><any>this.execution_start);
        }
        if (typeof this.execution_end === "string") {
            this.execution_end = new Date(<string><any>this.execution_end);
        }
        if (this.id) {
            models.RecordIdentity.fixupPrototype(this.id);
        }
        if (this.payload) {
            models.BackgroundJobPayloadBase.fixupPrototype(this.payload);
        }
        if (this.waiting_set) {
            for (let val of this.waiting_set) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
        if (this.waited_set) {
            for (let val of this.waited_set) {
                models.BackgroundJobIdentityWithStatus.fixupPrototype(val);
            }
        }
        if (this.waited_set_failed) {
            for (let val of this.waited_set_failed) {
                models.BackgroundJobIdentityWithStatus.fixupPrototype(val);
            }
        }
    }

    id: models.RecordIdentity;

    /**
     * When the Background Job was created
     */
    created_at: Date;

    /**
     * When the Background Job was last updated
     */
    updated_at: Date;

    /**
     * If True, the Background Job should stop processing as soon as possible
     */
    cancel_requested: boolean;

    /**
     * Status of Background Job
     */
    status: models.BackgroundJobStatus;

    /**
     * Mode of Background Job
     */
    mode: models.BackgroundJobMode;

    /**
     * Priority of the Background Job
     */
    priority: number;

    /**
     * When the Background Job will execute
     */
    next_activation: Date;

    /**
     * Identifier of the worker processing this job
     */
    worker_id: string;

    /**
     * When the Background Job started executing
     */
    execution_start: Date;

    /**
     * When the Background Job completed execution
     */
    execution_end: Date;

    /**
     * Number of auto retries left for this Background Job
     */
    auto_retries: number;

    /**
     * Number of seconds to wait before a retry for this Background Job
     */
    auto_retry_delay: number;

    /**
     * Details in case the execution of the job failed
     */
    failure: any;

    /**
     * Background Jobs this job is waiting for
     */
    waiting_set: Array<models.RecordIdentity>;

    /**
     * Background Jobs this job waited on
     */
    waited_set: Array<models.BackgroundJobIdentityWithStatus>;

    /**
     * Failed Background Jobs this job waited on
     */
    waited_set_failed: Array<models.BackgroundJobIdentityWithStatus>;

    /**
     * Data associated with the Background Job
     */
    payload: models.BackgroundJobPayloadBase;

}
